import RecommendationsForm from './RecommendationsForm';

export default RecommendationsForm;
